export const calculatePercentage = (data, length) => {
    const totalStudents = data.reduce((sum, obj) => sum + obj.studentsCount, 0);
    let convertedData = []
    for (let i = 1; i <= length; i++) {
        convertedData.push({
            solution: i,
            percentage: (data.find(ans => Number(ans.solution) === i)?.studentsCount / totalStudents) * 100 || 0
        })
    }
    return convertedData;
}
